<template>
    <Head title="Lounge" />
    <div class="px-4 md:px-8">
        <Lounge />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Lounge from '@/components/tools/lounges/lounge/index.vue';
</script>
